/** The hidden bot-trap field's name. Must match HONEYPOT_FIELD in src/server/security/honeypot.ts. */
export const HONEYPOT_FIELD = 'fax_number';

/** Style that hides the trap from people without display:none (which some bots skip). */
export const HONEYPOT_HIDDEN_STYLE = { position: 'absolute', left: '-9999px', width: 1, height: 1, overflow: 'hidden' } as const;
